angular.module('TetherApp').controller('NotificationController', [
    'ngToast',
    '$window',
    function (
        ngToast,
        $window
    ) {

        let self = this;

        self.messages = {};

        self.loadNotifications = function () {
            // self.messages = notificationService.getNotifications();
            // notificationService.getToasts(self.messages);
        };

    }
]);



